import React from "react"

const MyVideo = ({ videoSrcURL, videoTitle, ...props }) => (
    <div className="video">
        <iframe
            width="560"
            height ="315"
            src={videoSrcURL}
            title={videoTitle}
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            frameBorder="0"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen
        />
    </div>
)
export default MyVideo
